<script setup lang="ts">
import { getEnvVar } from "@/utils/env";
const cdnBaseUrl = getEnvVar("VITE_VACV_COMMON_STATIC_URL");
</script>
<template>
  <div class="vacv-loader" role="status">
    <img
      alt="Loading"
      :src="`${cdnBaseUrl}/img/components/loading/loading.png`"
    />
  </div>
</template>

<style scoped lang="scss">
.vacv-spa {
  .vacv-loader {
    margin-top: 30px;
    text-align: center;

    img {
      width: 50px;
      height: 50px;
      -webkit-animation: loader linear 1s infinite;
      animation: loader linear 1s infinite;

      &.loader-small {
        width: 20px;
        height: 20px;
      }
    }

    @keyframes loader {
      0% {
        transform: rotate(0deg);
      }

      100% {
        transform: rotate(360deg);
      }
    }
  }
}
</style>
